module.exports = __webpack_public_path__ + "static/media/ic_close_white.bc16fb16.svg";